var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({directives:[{name:"wave",rawName:"v-wave"}],ref:"button",class:['button', { 'icon-right': _vm.iconAlignRight, active: _vm.active, 'active-old': _vm.activeOld }],attrs:{"id":_vm.buttonId,"disabled":_vm.disabled}},_vm.listeners),[_c('div',{staticClass:"icon"},[_vm._t("icon")],2),(_vm.$slots.default)?_c('div',{class:[
      'text',
      {
        'icon-right': _vm.iconAlignRight,
        'icon-left': !_vm.iconAlignRight,
        'hidden-xs-and-down': _vm.hideTextMobile,
      } ]},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }